import { defineMessages } from 'react-intl';

export default defineMessages({
    yourHome: {
        id: 'quoteandbind.ba.wizard.step.Drivers',
        defaultMessage: 'Drivers'
    },
    construction: {
        id: 'quoteandbind.ba.wizard.step.Vehicles',
        defaultMessage: 'Vehicles'
    },
    getYourQuoteFaster: {
        id: 'quoteandbind.views.contact-details.ba.Get your quote faster!',
        defaultMessage: 'Get your quote faster!',
    },
    scanDriverLicenseDescription: {
        id: 'quoteandbind.views.contact-details.ba.Scan your driver license barcode to automatically enter the necessary information.',
        defaultMessage: 'Scan your driver license barcode to automatically enter the necessary information.',
    },
    scanDriverLicenseBarcode: {
        id: 'platform.documentupload.templates.document-upload.ba.Scan driver license barcode',
        defaultMessage: 'Scan driver license barcode',
    },
    scanDriverLicenseBarcodeAutomaticallyEnterDetails: {
        id: 'quoteandbind.views.contact-details.ba.Scan your driver license barcode to automatically enter the necessary information.',
        defaultMessage: 'Scan your driver license barcode to automatically enter the necessary information.',
    },
    construction: {
        id: 'quoteandbind.ba.wizard.step.Driver Assignment',
        defaultMessage: 'Driver Assignment'
    },
    construction: {
        id: 'quoteandbind.ba.wizard.step.Risk Analysis',
        defaultMessage: 'Risk Analysis'
    },
});
